import React from "react";
import classes from "./Icon.module.css";
import PokemonName from "../../../Util/PokemonName";
import ReactDOMServer from 'react-dom/server';

const fullpath = "https://raw.githubusercontent.com/Leanny/leanny.github.io/master/seedchecker/img/icons/";

const Icon = props => {
    let filename = "b_" + props.details.Species;
    if (props.details.Species === 744) {
        props.details.AltForm = 0;
    }
    if(props.details.AltForm > 0) {
        filename += "-" + props.details.AltForm;
    }

    let wrapperClass = [classes.Img];
    if(props.details.IsGigantamax) {
        wrapperClass.push(classes.Gmax);
    }
    if(props.details.ShinyForced) {
        if(props.details.ShinyForced === 1) {
            wrapperClass.push(classes.NoShiny);
        } else {
            wrapperClass.push(classes.Shiny);
        }
    }
    const name = ReactDOMServer.renderToStaticMarkup(<PokemonName id={props.details.Species} form={props.details.AltForm} />);
    return <div className={wrapperClass.join(" ")}><img src={fullpath+filename+".png"} alt={name} title={name} /><div className={classes.Break} />{name}</div>;
}

export default Icon;